import { render, staticRenderFns } from "./version_list.vue?vue&type=template&id=78ddd4b1&scoped=true"
import script from "./version_list.vue?vue&type=script&lang=js"
export * from "./version_list.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "78ddd4b1",
  null
  
)

export default component.exports